// src/utils/criticalDateLabels.js
//
// Canonical critical-date type → human-readable label mapping shared across
// all frontend surfaces that need to render critical date types.
//
// Kept in sync with server/lib/criticalDateLabels.js so both surfaces use the
// same source of truth and labels can't drift apart independently.
//
// Usage:
//   import { criticalDateLabel } from "../../utils/criticalDateLabels.js";
//   criticalDateLabel("renewal_notice")  // → "Renewal Notice"
//   criticalDateLabel("unknown_type")    // → "unknown_type"  (safe fallback)

export const CRITICAL_DATE_TYPE_LABELS = {
  renewal_notice:      "Renewal Notice",
  break_option:        "Break Option",
  expiration:          "Expiration",
  escalation:          "Escalation",
  deposit_burndown:    "Deposit Burndown",
  allowance_deadline:  "Allowance Deadline",
  allowance_warning:   "Allowance Warning",
  allowance_expiry:    "Allowance Expiry",
  cam_audit:           "CAM Audit",
  other:               "Other",
};

/**
 * Map a raw critical-date type slug to its canonical human-readable label.
 *
 * @param {string|null|undefined} type - Raw type from the DB (e.g. "renewal_notice").
 * @param {string|null|undefined} [description] - Free-form description. For the
 *   "other" type this is shown as "Other — <description>" when present; for
 *   unrecognised types it is used as a fallback label (mirrors the SQL ELSE branch).
 * @returns {string} Human-readable label, never null/undefined.
 */
export function criticalDateLabel(type, description) {
  if (!type) return "";
  if (type === "other" && description) return `Other \u2014 ${description}`;
  return CRITICAL_DATE_TYPE_LABELS[type] ?? description ?? type;
}
